import { render, staticRenderFns } from "./suggestionDetailDlg.vue?vue&type=template&id=8602762e&scoped=true"
import script from "./suggestionDetailDlg.vue?vue&type=script&lang=js"
export * from "./suggestionDetailDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8602762e",
  null
  
)

export default component.exports